import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';
import qs from 'query-string';
import CircularProgress from 'components/shared/CircularProgress';

const toParams = (params) => {
  const string = qs.stringify(params);

  return string ? `?${string}` : '';
};

const getURL = ({
  bookingId,
  conversationId,
  pathname,
  orderId,
  transaction,
  errorCode,
  errorMessage,
}) => {
  if (pathname) {
    return `/${pathname}`;
  }

  if (conversationId && bookingId) {
    return `/conversations/${conversationId}/bookings/${bookingId}${toParams({ transaction, errorCode, errorMessage })}`;
  }

  if (conversationId) {
    return `/conversations/${conversationId}`;
  }

  if (orderId) {
    return `/orders/${orderId}`;
  }

  return '/';
};

class TokenRedirect extends React.Component {
  UNSAFE_componentWillMount() {
    const { token } = qs.parse(this.props.location.search);
    if (token) {
      this.props.postAuthTokenRequest({ token });
    }
  }

  render() {
    const {
      isTokenSent,
      isTokenInvalid,
      location,
    } = this.props;

    const {
      token,
    } = qs.parse(location.search);

    if (!isTokenSent && token) {
      return (
        <CircularProgress fullHeight />
      );
    }

    const url = getURL(qs.parse(location.search));

    if (token && isTokenSent && isTokenInvalid) {
      return (
        <Redirect to={`/login?next=${url}`} />
      );
    }

    return (
      <Redirect to={url} />
    );
  }
}

TokenRedirect.propTypes = {
  isTokenSent: PropTypes.bool.isRequired,
  isTokenInvalid: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,

  postAuthTokenRequest: PropTypes.func.isRequired,
};

export default withRouter(TokenRedirect);
